import { Overlay } from "@components/Overlay";
import { useModal } from "@hooks";
import { Translations, i18n } from "@i18n";
import { Intercom } from "@services";

export const ChangeDetailsModal = () => {
  const { dismiss } = useModal();

  return (
    <Overlay
      title={i18n.t(Translations.ChangeDetailsModalTitle)}
      subtitle={i18n.t(Translations.ChangeDetailsModalSubtitle)}
      cta={{
        primary: {
          title: i18n.t(Translations.ChangeDetailsModalPrimaryCTA),
          onClick: () => {
            Intercom.showChat();
            dismiss();
          },
        },
        secondary: {
          title: i18n.t(Translations.ChangeDetailsModalSecondaryCTA),
          onClick: dismiss,
        },
      }}
      horizontal
    />
  );
};
